import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { yen } from "../lib/api";
import { useStore } from "../lib/store";

const digits = (v) => v.replace(/[^0-9]/g, "");

/** Kirim struk ke WhatsApp pembeli lewat wa.me (tanpa API berbayar). */
export const ReceiptWhatsApp = ({ order }) => {
  const { storeName, address, phone } = useStore();
  const [open, setOpen] = useState(false);
  const [num, setNum] = useState("");

  const text = () => {
    const lines = [
      `*${storeName}*`,
      `${address} · ${phone}`,
      "",
      `Struk No. ${order.order_no}`,
      new Date(order.paid_at || order.created_at).toLocaleString("id-ID"),
      "",
      ...order.items.map((it) => `${it.name} x${it.qty} — ${yen(it.price * it.qty)}`),
      "",
      `Subtotal: ${yen(order.subtotal)}`,
      ...(order.discount > 0 ? [`Diskon: -${yen(order.discount)}`] : []),
      `*Total: ${yen(order.total)}*`,
      ...(order.change > 0 ? [`Kembalian: ${yen(order.change)}`] : []),
      "",
      "Terima kasih atas kunjungan Anda 🙏",
    ];
    return lines.join("\n");
  };

  const send = () => {
    const to = digits(num);
    if (to.length < 8) return;
    window.open(
      `https://wa.me/${to}?text=${encodeURIComponent(text())}`,
      "_blank",
      "noopener"
    );
  };

  if (!open)
    return (
      <Button
        variant="outline"
        className="w-full text-emerald-700 border-emerald-200 hover:bg-emerald-50"
        data-testid="wa-receipt-open-btn"
        onClick={() => setOpen(true)}
      >
        <MessageCircle size={16} className="mr-1" /> Kirim struk ke WhatsApp
      </Button>
    );

  return (
    <div className="space-y-2">
      <p className="text-xs text-muted-foreground">
        Nomor WhatsApp pembeli (pakai kode negara, contoh 8190…)
      </p>
      <div className="flex gap-2">
        <Input
          data-testid="wa-receipt-number-input"
          value={num}
          onChange={(e) => setNum(digits(e.target.value))}
          inputMode="numeric"
          placeholder="819012345678"
        />
        <Button
          data-testid="wa-receipt-send-btn"
          disabled={digits(num).length < 8}
          onClick={send}
        >
          Kirim
        </Button>
      </div>
    </div>
  );
};
